module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","version":"1.0","width":"32","height":"8","viewBox":"0 0 64 16"},"content":"<circle fill=\"currentColor\" r=\"5.5\" transform=\"translate(8 8)\"><animateTransform attributeName=\"transform\" type=\"scale\" additive=\"sum\" values=\"0;1;1;1;0;0;0\" dur=\"1500ms\" repeatCount=\"indefinite\"/></circle><circle fill=\"currentColor\" r=\"5.5\" transform=\"translate(32 8)\"><animateTransform attributeName=\"transform\" type=\"scale\" additive=\"sum\" values=\"0;0;1;1;1;0;0\" dur=\"1500ms\" repeatCount=\"indefinite\"/></circle><circle fill=\"currentColor\" r=\"5.5\" transform=\"translate(56 8)\"><animateTransform attributeName=\"transform\" type=\"scale\" additive=\"sum\" values=\"0;0;0;1;1;1;0\" dur=\"1500ms\" repeatCount=\"indefinite\"/></circle>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
